var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogouticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9Z",
    fill: "#334D6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3C10 2.44772 9.55229 2 9.00001 2C8.44772 2 8.00001 2.44772 8.00001 3V6C8.00001 6.55229 8.44772 7 9.00001 7C9.55229 7 10 6.55228 10 6V3ZM13.9497 4.05025C13.5592 3.65973 12.9261 3.65973 12.5355 4.05025C12.145 4.44078 12.145 5.07394 12.5355 5.46447C13.2348 6.16373 13.711 7.05464 13.9039 8.02455C14.0969 8.99445 13.9978 9.99979 13.6194 10.9134C13.241 11.827 12.6001 12.6079 11.7779 13.1573C10.9556 13.7068 9.98891 14 9 14C8.0111 14 7.0444 13.7068 6.22215 13.1573C5.39991 12.6079 4.75904 11.827 4.38061 10.9134C4.00217 9.99979 3.90315 8.99445 4.09608 8.02455C4.289 7.05464 4.76521 6.16373 5.46447 5.46447C5.85499 5.07394 5.85499 4.44078 5.46447 4.05025C5.07394 3.65973 4.44078 3.65973 4.05026 4.05025C3.07129 5.02922 2.4046 6.2765 2.13451 7.63437C1.86441 8.99224 2.00303 10.3997 2.53285 11.6788C3.06266 12.9579 3.95987 14.0511 5.11101 14.8203C6.26216 15.5895 7.61553 16 9 16C10.3845 16 11.7379 15.5895 12.889 14.8203C14.0401 14.0511 14.9373 12.9579 15.4672 11.6788C15.997 10.3997 16.1356 8.99223 15.8655 7.63437C15.5954 6.2765 14.9287 5.02922 13.9497 4.05025Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogouticon);
export default __webpack_public_path__ + "static/media/logouticon.25a191f67e5624af3977edf20e760dc7.svg";
export { ForwardRef as ReactComponent };